import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {useLazyCheckTokenQuery, useLazySetProfileDetailsQuery} from "../../../Store/Builder/techsbook.api";
import { setLoader, setUserData } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useCreatePasswordApi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [setPasswordApi] = useLazySetProfileDetailsQuery();
  const [checkTokenApi] = useLazyCheckTokenQuery();

  const send = (data) => {
    dispatch(setLoader(true));
    setPasswordApi({ ...location?.state, ...data })
      .unwrap()
      .then((res) => {
        localStorage.setItem("techsbook_customer_portal_token", res?.token);
        showToast(res?.message ?? "Success", "success");
        dispatch(setUserData(res?.account));
        dispatch(setLoader(false));

        if (!res?.account?.registration_completed) {
          navigate("/register-details", { state: { ...res } });
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message, "error");
      });
  };

  const sendWithToken = (data) => {
    dispatch(setLoader(true));
    setPasswordApi(data)
      .unwrap()
      .then((res) => {
        localStorage.setItem("techsbook_customer_portal_token", res?.token);
        showToast(res?.message ?? "Success", "success");
        dispatch(setUserData(res?.account));
        dispatch(setLoader(false));

        if (!res?.account?.registration_completed) {
          navigate("/register-details", { state: { ...res } });
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message, "error");
      });
  };
  const checkToken = (data) => {
    dispatch(setLoader(true));
    checkTokenApi(data)
      .unwrap()
      .then((res) => {
        showToast(res?.message ?? "Token checked successfully!", "success");
        location.state.member_uid = data?.member_uid;
        location.state.password_token = data?.password_token;
      })
      .catch((err) => {
        showToast(err?.data?.message, "error");
      })
      .finally(() => {
        dispatch(setLoader(false));
      })
  };

  return {
    send,
    checkToken,
    sendWithToken
  };
};

export default useCreatePasswordApi;
